import { useState } from 'react';
import Text from '../../../components/Text';
import { Divider, Upload, UploadFile, UploadProps } from 'antd';
import Button from '../../../components/Button';
import { RcFile } from 'antd/es/upload';

type UploadGiftCardImageProps = {
  value?: string;
  onChange?: (value: string) => void;
};

const { Dragger } = Upload;

const UploadGiftCardImage = ({ value, onChange }: UploadGiftCardImageProps) => {
  const src = value || '/images/icon_image.png';
  const [fileList, setFileList] = useState<UploadFile[]>([]);

  const toBase64 = (file: RcFile) =>
    new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = reject;
    });

  const props: UploadProps = {
    name: 'file',
    multiple: false,
    accept: 'image/*',
    listType: 'picture-card',
    showUploadList: false,
    fileList,
    beforeUpload: () => false,
    async onChange(info) {
      const { fileList: newList } = info;
      const nextList = newList.slice(-1);
      const newFile = nextList?.[0];
      if (newFile?.originFileObj) {
        const base64 = await toBase64(newFile?.originFileObj as RcFile);
        onChange?.(base64);
        const idx = nextList.findIndex((f) => f.uid === newFile.uid);
        if (idx > -1) nextList[idx] = { ...nextList[idx], url: base64, status: 'done' };
      }

      setFileList(nextList);
    },
    style: {
      padding: '1rem 2rem',
      borderColor: '#000',
      backgroundColor: 'rgba(244, 248, 251, 1)',
      boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
    },
  };

  return (
    <Dragger {...props}>
      {value ? (
        <div>
          <img id='dataImage-upload' src={src} alt='upload' width={'50%'} />
        </div>
      ) : (
        <div>
          <img id='dataImage' src={'/images/icon_image.png'} alt='upload' />
          <Text variant='H8' style={{ color: 'rgba(86, 106, 127, 1)' }}>
            Drag your photos here to start uploading.
          </Text>
          <Divider style={{ color: 'rgba(86, 106, 127, 1)' }}>Or</Divider>
          <Button variant='SECONDARY'>Choose Image</Button>
        </div>
      )}
    </Dragger>
  );
};

export default UploadGiftCardImage;
